/* Riar theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var R = window.RIAR || { routes: { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart', root: '/' } };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Header shadow ---------- */
  var header = $('[data-header]');
  function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Mobile menu ---------- */
  var mmenu = $('[data-mmenu]');
  function setMenu(open) {
    if (!mmenu) return;
    mmenu.classList.toggle('is-open', open);
    mmenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('no-scroll', open);
    var btn = $('[data-menu-open]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-drawer]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('no-scroll', open);
  }

  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }

  function refreshCart() {
    return Promise.all([
      fetch(R.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }),
      fetch(R.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var html = res[0]['cart-drawer'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = $('[data-drawer-content]', doc);
        var panel = $('[data-drawer-content]');
        if (next && panel) panel.innerHTML = next.innerHTML;
      }
      updateCount(res[1].item_count);
      return res[1];
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-menu-open]')) { setMenu(true); return; }
    if (t.closest('[data-menu-close]')) { setMenu(false); return; }
    if (mmenu && t.closest('[data-mmenu] a')) { setMenu(false); }

    if (t.closest('[data-cart-open]')) {
      if (document.body.classList.contains('template-cart') || !drawer) {
        window.location.href = R.routes.cart;
      } else {
        setDrawer(true);
      }
      return;
    }
    if (t.closest('[data-drawer-close]')) { setDrawer(false); return; }

    var change = t.closest('[data-cart-change]');
    if (change) {
      e.preventDefault();
      change.disabled = true;
      fetch(R.routes.cart_change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(change.getAttribute('data-line'), 10), quantity: parseInt(change.getAttribute('data-qty'), 10) })
      }).then(function (r) { return r.json(); }).then(function () {
        if ($('[data-cart-page]')) { window.location.reload(); } else { refreshCart(); }
      }).catch(function () { change.disabled = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setDrawer(false); setMenu(false); }
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    // let dynamic checkout buttons (Buy it now) submit normally
    if (e.submitter && e.submitter.name && e.submitter.name !== 'add') return;
    e.preventDefault();

    var btn = $('[data-add-btn]', form);
    var label = $('[data-add-label]', form);
    var err = $('[data-buy-error]', form);
    var original = label ? label.textContent : '';
    if (err) { err.classList.remove('is-visible'); err.textContent = ''; }
    if (btn) { btn.setAttribute('aria-disabled', 'true'); }
    if (label) label.textContent = 'Adding…';

    var data = new FormData();
    data.append('id', $('[data-variant-id]', form).value);
    data.append('quantity', ($('[data-qty-input]', form) || { value: 1 }).value || 1);

    fetch(R.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (err) { err.textContent = res.body.description || res.body.message || 'Could not add to cart.'; err.classList.add('is-visible'); }
          if (label) label.textContent = original;
          if (btn) btn.removeAttribute('aria-disabled');
          return;
        }
        return refreshCart().then(function () {
          if (label) label.textContent = original;
          if (btn) btn.removeAttribute('aria-disabled');
          setDrawer(true);
        });
      })
      .catch(function () {
        if (label) label.textContent = original;
        if (btn) btn.removeAttribute('aria-disabled');
        // graceful fallback: normal form post
        form.submit();
      });
  });

  /* ---------- Sort select ---------- */
  var sort = $('[data-sort-select]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(sec) {
    var vEl = $('[data-variants]', sec);
    var form = $('form[data-type="add-to-cart-form"]', sec);
    if (!vEl || !form) return;

    var variants = [];
    try { variants = JSON.parse(vEl.textContent); } catch (err) { return; }

    var idInput = $('[data-variant-id]', form);
    var priceEl = $('[data-price]', sec);
    var sbar = $('[data-sbar]', sec);
    var sbarPrice = $('[data-sbar-price]', sec);
    var sbarBtn = $('[data-sbar-add]', sec);
    var addBtn = $('[data-add-btn]', form);
    var addLabel = $('[data-add-label]', form);
    var fieldsets = $$('.opt', form);
    var track = $('[data-gallery-track]', sec);
    var dotsWrap = $('[data-gallery-dots]', sec);

    function selected() {
      return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function matches(v, vals) {
      return vals.every(function (val, i) { return val === null || val === v['option' + (i + 1)]; });
    }
    function priceHtml(v, withOff) { if (v && /advance/i.test(v.option1)) v = variants.filter(function (x) { return !/advance/i.test(x.option1); })[0] || v;
      var h = '<span class="price"><span>' + v.price + '</span>';
      if (v.compare) {
        h += '<small class="price__mrp">MRP <s>' + v.compare + '</s></small>';
        if (withOff && v.off) h += '<span class="price__off">' + v.off + '% off</span>';
      }
      return h + '</span>';
    }
    function setButtons(v) {
      var ok = !!(v && v.available);
      var text = !v ? 'Unavailable' : (v.available ? 'Add to cart' : 'Sold out');
      [addBtn, sbarBtn].forEach(function (b) { if (b) b.disabled = !ok; });
      if (addLabel) addLabel.textContent = text;
      if (sbarBtn) sbarBtn.textContent = text;
    }
    function markUnavailable() {
      var vals = selected();
      fieldsets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (input) {
          var test = vals.slice();
          test[i] = input.value;
          var any = variants.some(function (v) { return v.available && matches(v, test); });
          input.classList.toggle('is-unavailable', !any);
        });
      });
    }
    function showMedia(id) {
      if (!id || !track) return;
      var item = $('[data-media-id="' + id + '"]', track);
      if (!item) return;
      if (window.matchMedia('(max-width: 989px)').matches) {
        track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      } else {
        var hh = header ? header.offsetHeight : 0;
        window.scrollTo({ top: item.getBoundingClientRect().top + window.scrollY - hh, behavior: 'smooth' });
      }
    }
    function onChange() {
      var vals = selected();
      var v = variants.filter(function (x) { return matches(x, vals); })[0];
      fieldsets.forEach(function (fs, i) {
        var l = $('[data-option-label]', fs);
        if (l) l.textContent = vals[i] || '';
      });
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = priceHtml(v, true);
        if (sbarPrice) sbarPrice.innerHTML = priceHtml(v, false);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (err) { /* ignore */ }
        showMedia(v.media);
      }
      setButtons(v);
      markUnavailable();
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', onChange); });
    if (fieldsets.length) markUnavailable();

    /* quantity */
    var qtyInput = $('[data-qty-input]', form);
    function setQty(n) { qtyInput.value = Math.max(1, Math.min(99, n || 1)); }
    var minus = $('[data-qty-minus]', form), plus = $('[data-qty-plus]', form);
    if (qtyInput) {
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });
      qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10)); });
    }

    /* gallery dots (mobile) */
    if (track && dotsWrap) {
      var items = $$('.pg__item', track);
      if (items.length > 1) {
        items.forEach(function (it, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'pg__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Go to image ' + (i + 1));
          d.addEventListener('click', function () { track.scrollTo({ left: it.offsetLeft, behavior: 'smooth' }); });
          dotsWrap.appendChild(d);
        });
        var dots = $$('.pg__dot', dotsWrap);
        var raf;
        track.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var i = Math.round(track.scrollLeft / track.clientWidth);
            dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
          });
        }, { passive: true });
      }
    }

    /* sticky buy bar */
    if (sbar && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sbar.classList.toggle('is-visible', show);
        sbar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(addBtn);
    }
    if (sbarBtn) {
      sbarBtn.addEventListener('click', function () {
        if (form.requestSubmit && addBtn) { form.requestSubmit(addBtn); } else if (addBtn) { addBtn.click(); }
      });
    }
  }
  $$('[data-product-section]').forEach(initProduct);

  /* Re-init when the section is re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(initProduct);
  });
})();
